<script>
import { mapGetters } from 'vuex';
import { useAlert, useTrack } from 'dashboard/composables';
import BotDashboard from './components/bot/BotDashboard.vue';
import ReportFilterSelector from './components/FilterSelector.vue';
import { GROUP_BY_FILTER } from './constants';
import { REPORTS_EVENTS } from '../../../../helper/AnalyticsHelper/events';

export default {
  name: 'BotReports',
  components: {
    BotDashboard,
    ReportFilterSelector,
  },
  data() {
    return {
      from: 0,
      to: 0,
      groupBy: GROUP_BY_FILTER[1],
      businessHours: false,
      conversationDirection: false,
      comunicanteCampaign: 'all',
    };
  },
  computed: {
    ...mapGetters({
      botSummary: 'getBotSummary',
      summaryUIFlags: 'getReportSummaryUIFlags',
    }),
    requestPayload() {
      return {
        from: this.from,
        to: this.to,
        groupBy: this.groupBy?.period,
        businessHours: this.businessHours,
        conversationDirection: this.conversationDirection,
        comunicanteCampaign: this.comunicanteCampaign,
      };
    },
  },
  methods: {
    fetchAllData() {
      this.fetchBotSummary();
    },
    fetchBotSummary() {
      try {
        this.$store.dispatch('fetchBotSummary', this.getRequestPayload());
      } catch {
        useAlert(this.$t('REPORT.SUMMARY_FETCHING_FAILED'));
      }
    },
    getRequestPayload() {
      const {
        from,
        to,
        groupBy,
        businessHours,
        conversationDirection,
        comunicanteCampaign,
      } = this;

      return {
        from,
        to,
        groupBy: groupBy?.period,
        businessHours,
        conversationDirection,
        comunicanteCampaign,
      };
    },
    onFilterChange({
      from,
      to,
      groupBy,
      businessHours,
      selectedConversationDirection,
      selectedComunicanteCampaign,
    }) {
      this.from = from;
      this.to = to;
      this.groupBy = groupBy;
      this.businessHours = businessHours;
      this.conversationDirection = selectedConversationDirection.id;
      this.comunicanteCampaign = selectedComunicanteCampaign.id;
      this.fetchAllData();

      useTrack(REPORTS_EVENTS.FILTER_REPORT, {
        filterValue: { from, to, groupBy, businessHours },
        reportType: 'bots',
      });
    },
  },
};
</script>

<template>
  <div class="flex-1 p-4 overflow-auto">
    <ReportFilterSelector
      :show-agents-filter="false"
      show-group-by-filter
      :show-business-hours-switch="false"
      @filter-change="onFilterChange"
    />

    <div>
      <BotDashboard
        :filters="requestPayload"
        :bot-summary="botSummary"
        :is-summary-loading="summaryUIFlags.isFetchingBotSummary"
      />
    </div>
  </div>
</template>
